import React, { useEffect, useState } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { View, Spin } from '@components';

import Store from './store';
import ptBR from 'antd/es/locale/pt_BR';

import RoutesContext from './routes/Context';
import routes, { Routes } from './routes';
import { getTheme, applyTheme } from '@app/Theme';
import styled from 'styled-components';

const LoadingView = styled(View)`
  padding-top: 30px;
`;

const Main = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    applyTheme(getTheme()).then(() => {
      setLoading(false);
    });
  }, []);

  return (loading) ? (
    <LoadingView>
      <Spin />
    </LoadingView>
  ) : (
    <RoutesContext.Provider value={routes}>
      <ConfigProvider locale={ptBR}>
        <ReduxProvider store={Store}>
          <Routes routes={routes} />
        </ReduxProvider>
      </ConfigProvider>
    </RoutesContext.Provider>    
  );
};

export default Main;
